import { Map, OrderedSet } from 'immutable';

import * as types from './../types';
import { OWNER_FILTER_KEYS } from '../../../constants';

const initialState = Map({
  owners: OrderedSet(),
  loading: false,
});

const ownersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_OWNERS.REQUEST: {
      return state.withMutations((newState) => {
        newState
          .set('owners', OrderedSet())
          .set('loading', true);
      });
    }
    case types.ADD_ORGANIZATION: {
      const owners = state.get('owners');
      const organizationFilter = {
        name: 'organization', label: 'My Organization',
      };
      return state.set('owners', owners.add(organizationFilter));
    }
    case types.ADD_USERNAME: {
      const owners = state.get('owners');
      const { name, id } = payload;
      const usernameFilter = {
        name: 'myself', label: `My Tests (${name})`, id,
      };
      return state.set('owners', owners.add(usernameFilter));
    }
    case types.ADD_TEAM: {
      const owners = state.get('owners');
      const { name, id } = payload;
      const teamFilter = {
        name: 'team', label: `My Team (${name})`, id,
      };
      return state.set('owners', owners.add(teamFilter));
    }
    case types.GET_ORGANIZATION_USERS.SUCCESS: {
      const owners = state.get('owners');
      const organizationUsers = payload.results.map(({ id, username }) => ({
        name: username, label: username, id, type: OWNER_FILTER_KEYS.USER,
      }));
      return state.set('owners', owners.union(organizationUsers));
    }
    case types.GET_TEAMS.SUCCESS: {
      const teams = payload.results.map(({ name, id }) => ({
        name: id, label: name, id, type: OWNER_FILTER_KEYS.TEAM,
      }));
      const owners = state.get('owners');
      return state.set('owners', owners.union(teams));
    }
    case types.FETCH_OWNERS.SUCCESS:
    case types.FETCH_OWNERS.FAILURE:
      return state.set('loading', false);
    default:
      return state;
  }
};

export default ownersReducer;
export { initialState };
